/* eslint-disable no-param-reassign */
import produce from "immer";
// eslint-disable-next-line camelcase
import jwt_decode from "jwt-decode";

const INITIAL_STATE = {
  token: null,
  signed: false,
  loading: false,
  role: null,
};

export default function auth(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case "@auth/SIGN_IN_REQUEST": {
        draft.loading = true;
        break;
      }

      case "@auth/SIGN_IN_SUCCESS": {
        draft.token = action.payload.token;
        draft.role = jwt_decode(action.payload.token).systemRole;
        draft.signed = true;
        draft.loading = false;
        break;
      }

      case "@auth/SIGN_FAILURE": {
        draft.loading = false;
        break;
      }

      case "@auth/SIGN_OUT": {
        draft.token = null;
        draft.signed = false;
        draft.role = null;
        break;
      }

      default:
    }
  });
}
